import { type OnChangeFn, type SortingState, type ColumnDef, type RowData } from "@tanstack/react-table";
import { DndContextProvider } from "./DndContextProvider";
import { TableImplementation } from "./TableImplementation";
import { useTableColumnOrder } from "@/components/DataTable/useTableColumnOrder";
import { FilterConfig } from "@/components/DataTable/Filters/TableFilters";
export interface TableProps<TData extends RowData> {
  data: Array<TData>;
  tableId: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  columns: Array<ColumnDef<TData, any>>;
  filterConfig?: Array<FilterConfig>;
  loading: boolean;
  errorMessage?: string;
  sortConfig?: {
    sorting: SortingState;
    onSortingChange: OnChangeFn<SortingState>;
  };
  onRowClick?: (row: TData) => void;
  toolbarActions?: React.ReactNode;
  pagination?: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    pageSize: number;
    onPageChange: (page: number) => void;
    onPageSizeChange?: (pageSize: number) => void;
    pageSizeOptions?: number[];
  };
}

export function DataTable<TData extends RowData>({
  data,
  tableId,
  sortConfig,
  columns,
  filterConfig,
  loading,
  errorMessage,
  onRowClick,
  toolbarActions,
  pagination,
}: TableProps<TData>) {
  const { columnOrder, handleDragEnd, onColumnOrderChange } = useTableColumnOrder(tableId, columns);

  return (
    <DndContextProvider onDragEnd={handleDragEnd}>
      <TableImplementation
        columns={columns}
        filterConfig={filterConfig}
        loading={loading}
        errorMessage={errorMessage}
        data={data}
        tableId={tableId}
        columnOrder={columnOrder}
        onColumnOrderChange={onColumnOrderChange}
        sortConfig={sortConfig}
        onRowClick={onRowClick}
        toolbarActions={toolbarActions}
        pagination={pagination}
      />
    </DndContextProvider>
  );
}
